<template>
  <div class="q-pa-md">
    <div class="row justify-center">
      <div class="col col-lg-6">
        <q-table :rows="rows" :columns="columns" :loading="pending" row-key="id" v-model:pagination="pagination" @request="onRequest" :rows-per-page-options="[0]" :filter="filter"
          no-data-label="Nenhum dado cadastrado."
          no-results-label="Nenhum dado encontrado."
          loading-label="Carregando..."
        >
          <template v-slot:top-right>
            <q-input dense debounce="300" v-model="filter" placeholder="Pesquisar">
              <template v-slot:append>
                <q-icon name="close" @click="filter = ''" class="cursor-pointer" />
                <q-icon name="search" />
              </template>
            </q-input>
          </template>

          <template v-slot:no-data="{ icon, message, filter }">
            <div class="full-width row flex-center q-gutter-sm">
              <span>
                {{ message }}
              </span>
              <q-icon size="2em" :name="filter ? 'search' : icon" />
            </div>
          </template>

          <template v-slot:body-cell-action="props">
            <q-td :props="props">
              <q-btn color="primary" icon-right="edit" no-caps flat dense :to="{ name: 'User.Edit', params: { id: props.row.id } }"/>
              <q-btn color="negative" icon-right="delete" no-caps flat dense @click="handleDelete(props.row.id)"/>
            </q-td>
          </template>
        </q-table>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';

import getCollection from '@/composables/getCollection';
import useModel from '@/composables/useModel';
import handleDelete from '@/composables/handleDelete';
import columns from '@/composables/pages/users/columns';

export default {
  setup () {
    const { data, meta, pending, error, load } = getCollection('users');
    const { destroy } = useModel('users');

    const filter = ref('');
    const pagination = ref({
      sortBy: 'created_at',
      descending: true,
      page: 1,
      rowsPerPage: 15,
    });

    const reloadCollection = async () => {
      await load({ ...pagination.value, filter: filter.value });
      pagination.value.rowsNumber = meta.value.total;
    }

    const onRequest = (props) => {     
      const { page, rowsPerPage, sortBy, descending } = props.pagination;

      pagination.value.page = page
      pagination.value.rowsPerPage = rowsPerPage
      pagination.value.sortBy = sortBy
      pagination.value.descending = descending
      filter.value = props.filter

      reloadCollection();
    }

    onMounted(() => {
      onRequest({
        pagination: pagination.value
      });
    });

    return {
      columns, 
      rows: data, pending, error, meta,
      reloadCollection, handleDelete,
      pagination, onRequest, filter,
      destroy
    }
  }
}
</script>

<style>

</style>